import {GTM} from "../utils/gtml";

interface NativeMailSentEvent extends Event {
  detail: { inputs: { name: string; value: string }[] };
}

export class NewsletterSubscription {

  public static element1: HTMLElement;
  public static $element1: JQuery<HTMLElement>;

  public static element2: HTMLElement;
  public static $element2: JQuery<HTMLElement>;


  public static init() {

    NewsletterSubscription.$element1 = $('.Footer-Newsletter');
    NewsletterSubscription.$element2 = $('.Newsletter-subscription');

    NewsletterSubscription.events();

    if (NewsletterSubscription.$element1.length > 0) {
      NewsletterSubscription.setupGTMEvents(NewsletterSubscription.$element1);
    }

    if (NewsletterSubscription.$element2.length > 0) {
      NewsletterSubscription.setupGTMEvents(NewsletterSubscription.$element2);
    }
  }


  public static events() {

    NewsletterSubscription.$element1.find('form').on("submit", function (e) {
      //e.preventDefault();
      NewsletterSubscription.processNewsletter(NewsletterSubscription.$element1);
    });

    NewsletterSubscription.$element2.find('form').on("submit", function (e) {
      //e.preventDefault();
      NewsletterSubscription.processNewsletter(NewsletterSubscription.$element2);
    });

  }


  public static validateEmail(email: string) {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  public static processNewsletter(el: JQuery<HTMLElement>) {
    let email = el.find('input[type="email"]').val().toString();
    let lang = document.documentElement.lang;
    lang = lang.substring(0, 2);

    if (NewsletterSubscription.validateEmail(email)) {

      const homeUrl = $('body').attr('data-home-url');
      let newsletterData = {
        email: email,
        form_name: "newsletter",
        form_origin: window.location.hostname,
        form_language: lang,
        newsletterType: "ktb"
      }

      $.ajax({
        url: homeUrl + "/wp-content/themes/ktb-v2/src/modules/loyalty-webmecanik/webmecanikFunctions.php",
        data: newsletterData,
        success() {
          NewsletterSubscription.showSuccess(el, lang);
        },
        error() {
          NewsletterSubscription.showError(el, lang);
        },
        method: "POST",
      });

    } else {
      NewsletterSubscription.showError(el, lang);
    }
  }


  public static showSuccess(element:JQuery<HTMLElement>, language:any) {

    if (language == 'en') {
      //element.find('.form-response-output').text("Thank you for your registration.");
    } else if (language == 'it') {
      //element.find('.form-response-output').text("Grazie per la tua registrazione.");
    } else {
      //element.find('.form-response-output').text("Merci pour votre inscription.");
    }

  }


  public static showError(element:JQuery<HTMLElement>, language:any) {

    if (language == 'en') {
      //element.find('.form-response-output').text("Error");
    } else if (language == 'it') {
      //element.find('.form-response-output').text("Errore");
    } else {
      //element.find('.form-response-output').text("Erreur");
    }

  }


  public static setupGTMEvents($el: JQuery<HTMLElement>) {
    const contactFormElement = $el.find('.wpcf7');
    contactFormElement.get(0).addEventListener('wpcf7mailsent', (e: NativeMailSentEvent) => {
      const inputs = e.detail.inputs;
      const emailInput = inputs.find((i) => i.name === 'email');
      GTM.add({'event':'newsletter','email': emailInput.value});
    });
  }

}
